export default {
  RESOURCE_REQUEST: Symbol('RESOURCE_REQUEST'),
  RESOURCE_SUCCEED: Symbol('RESOURCE_SUCCEED'),
  RESOURCE_FAIL: Symbol('RESOURCE_FAIL'),
  RESOURCE_RESET: Symbol('RESOURCE_RESET'),
};
